import { computed } from "vue";
import { useActionNeededStore } from "@/stores";
import { isValidScope } from "@/constants/scope";

/**
 * Server-persisted "Action Needed" chip visibility, scoped per-table.
 *
 * Backed by `actionNeededStore` (server-side), so the user's toggle survives
 * navigation and hard refresh within a login session; every login resets it to
 * on (LAM-5340, previously persisted across logins — LAM-4269). The returned
 * computed exposes `.value` read/write semantics identical to a plain
 * ref so existing call sites (`showActionNeeded.value = false`) work unchanged.
 *
 * @param {"pa"|"intake"} scope
 */
export function useActionNeededPref(scope) {
  if (!isValidScope(scope)) {
    throw new Error(`useActionNeededPref: scope must be "pa" or "intake", got ${scope}`);
  }
  const store = useActionNeededStore();
  store.ensureLoaded();
  return computed({
    get: () => store.showChip[scope],
    // Fire-and-forget from a v-model setter; the store reverts optimistically on failure.
    set: (val) => {
      store.setShowChip(scope, val).catch(() => {});
    },
  });
}
